import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {IModuleSchema} from '@shared/models/moduleSchema';
import {finalize, map, shareReplay} from 'rxjs/operators';
import {UtilsService} from '@shared/utils/util';

@Injectable()
export class ModuleSchemaService {
  private readonly table = 'schema';
  private inflightList$: Observable<IModuleSchema[]> | null = null;

  constructor(private httpClient: HttpClient) {
  }

  public getAllTablesSchema(): Observable<IModuleSchema[]> {
    if (!this.inflightList$) {
      this.inflightList$ = this.httpClient.get<IModuleSchema[]>(`/app/${this.table}`)
        .pipe(
          map(modules => UtilsService.sortModules(modules)),
          finalize(() => { this.inflightList$ = null; }),
          shareReplay({ bufferSize: 1, refCount: true }),
        );
    }
    return this.inflightList$;
  }

  /** Clear shared in-flight handle (e.g. after logout / tenant switch). */
  resetInflight(): void {
    this.inflightList$ = null;
  }
}
